/* =========================
   FITMENT FINDER — JS ASSET (FULL FILE)
   File: assets/fitment-finder.js
   Mount:
   - <div id="fitmentFinder" class="ff-wrap"></div>
   ========================= */

(function () {
  // -------------------------
  // CONFIG
  // -------------------------
  var CONTACT_URL = "/pages/contact";

  // Handles / pulls add-ons (supports hinge-style pack planning: 20/10 + singles)
  // Note: If a handle doesn't have certain pack products (10-pack, etc.), the planner will safely round up using what exists.
  var HANDLE_ADDONS = [
    {
      key: "skyline_black",
      label: "Skyline Pull — Matte Black",
      // Variants live inside this ONE product:
      product_handle: "skyline-cabinet-pull-matte-black-5-3-64-single-pull",
      unitLabel: "pulls",
      single: { sku: "PULL_MB_1S-1", id: 43950833533021, packSize: 1 },
      pack10: { sku: "PULL_MB_10PK-1", id: 43950272675933, packSize: 10 },
      pack20: { sku: "PULL_MB_20PK-2", id: 43950272708701, packSize: 20 }
    },
    {
      key: "skyline_brass",
      label: "Skyline Pull — Brushed Satin Brass",
      // Variants live inside this ONE product:
      product_handle: "skyline-cabinet-pull-brushed-brass-5-3-64-single-pull",
      unitLabel: "pulls",
      single: { sku: "PULL_BB_1S-1", id: 43950806696029, packSize: 1 },
      pack10: { sku: "PULL_BB_10PK-1", id: 43950068301917, packSize: 10 },
      pack20: { sku: "PULL_BB_20PK-2", id: 43950068334685, packSize: 20 }
    }
  ];

  // Required accessories per your request
  var ACCESSORY_ADDONS = [
    {
      key: "screws100",
      label: '#7 x 3/4" Screws — 100ct pack',
      handle: "screw-pack-7x34-universal-100",
      defaultQty: 1,
      showIf: function () { return true; }
    },
    {
      key: "ffJig",
      label: "Half-Overlay Door Mounting Jig (Face Frame)",
      handle: "half-overlay-door-mounting-jig",
      defaultQty: 1,
      showIf: function (state) { return state.cabinet === "face_frame"; }
    }
  ];

  // -------------------------
  // PLATE RANGES (your rule)
  // 0mm: 5/8–3/4
  // 3mm: 1/2–9/16
  // 6mm: 1/4–7/16
  // -------------------------
  var PLATE_RANGES = {
    "0": { min: 0.625, max: 0.75, label: '5/8"–3/4"' },
    "3": { min: 0.5, max: 0.5625, label: '1/2"–9/16"' },
    "6": { min: 0.25, max: 0.4375, label: '1/4"–7/16"' }
  };

  function plateMid(plate) {
    var r = PLATE_RANGES[String(plate)];
    if (!r) return NaN;
    return (r.min + r.max) / 2;
  }

  function plateForOverlay(overlayIn) {
    if (!isFinite(overlayIn)) return null;

    // 1) direct in-range match
    var keys = ["0", "3", "6"];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], r = PLATE_RANGES[k];
      if (overlayIn >= r.min && overlayIn <= r.max) return k;
    }

    // 2) closest midpoint if not in any band
    var best = "0";
    var bestD = Math.abs(overlayIn - plateMid(best));
    for (var j = 0; j < keys.length; j++) {
      var kk = keys[j];
      var d = Math.abs(overlayIn - plateMid(kk));
      if (d < bestD) { best = kk; bestD = d; }
    }
    return best;
  }

  function confidenceForPlate(overlayIn, plate) {
    if (!isFinite(overlayIn)) return null;
    plate = String(plate);
    var r = PLATE_RANGES[plate];
    if (!r) return null;

    var inRange = (overlayIn >= r.min && overlayIn <= r.max);
    var nearTol = 0.0625; // 1/16"

    if (inRange) return { label: "High", level: "good" };

    if (overlayIn >= (r.min - nearTol) && overlayIn <= (r.max + nearTol)) {
      return { label: "Medium", level: "warn" };
    }

    return { label: 'Low — please contact us with further information', level: "bad" };
  }

  // -------------------------
  // MATRIX (core mapping)
  // -------------------------
  var MATRIX = [
    // -------- Hinges (Frameless / Euro overlay) --------
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 10, "plate_height_mm": 0, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-frameless-euro-overlay-10-door", "variant_sku": "DH-FR-EU-SC-10-0", "match_options_json": "{\"Pack Size\": \"10\", \"Plate Height\": \"0 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 10, "plate_height_mm": 3, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-frameless-euro-overlay-10-door", "variant_sku": "DH-FR-EU-SC-10-3", "match_options_json": "{\"Pack Size\": \"10\", \"Plate Height\": \"3 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 10, "plate_height_mm": 6, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-frameless-euro-overlay-10-door", "variant_sku": "DH-FR-EU-SC-10-6", "match_options_json": "{\"Pack Size\": \"10\", \"Plate Height\": \"6 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 20, "plate_height_mm": 0, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-frameless-euro-overlay-10-door", "variant_sku": "DH-FR-EU-SC-20-0", "match_options_json": "{\"Pack Size\": \"20\", \"Plate Height\": \"0 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 20, "plate_height_mm": 3, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-frameless-euro-overlay-10-door", "variant_sku": "DH-FR-EU-SC-20-3", "match_options_json": "{\"Pack Size\": \"20\", \"Plate Height\": \"3 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 20, "plate_height_mm": 6, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-frameless-euro-overlay-10-door", "variant_sku": "DH-FR-EU-SC-20-6", "match_options_json": "{\"Pack Size\": \"20\", \"Plate Height\": \"6 mm\"}", "sku_disambiguator": "" },

    // -------- Hinges (Face Frame / Half overlay) --------
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 10, "plate_height_mm": 0, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-face-frame-half-overlay-10-door", "variant_sku": "DH-FF-HO-SC-10-0", "match_options_json": "{\"Pack Size\": \"10\", \"Plate Size\": \"0 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 10, "plate_height_mm": 3, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-face-frame-half-overlay-10-door", "variant_sku": "DH-FF-HO-SC-10-3", "match_options_json": "{\"Pack Size\": \"10\", \"Plate Size\": \"3 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 10, "plate_height_mm": 6, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-face-frame-half-overlay-10-door", "variant_sku": "DH-FF-HO-SC-10-6", "match_options_json": "{\"Pack Size\": \"10\", \"Plate Size\": \"6 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 20, "plate_height_mm": 0, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-face-frame-half-overlay-10-door", "variant_sku": "DH-FF-HO-SC-20-0", "match_options_json": "{\"Pack Size\": \"20\", \"Plate Size\": \"0 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 20, "plate_height_mm": 3, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-face-frame-half-overlay-10-door", "variant_sku": "DH-FF-HO-SC-20-3", "match_options_json": "{\"Pack Size\": \"20\", \"Plate Size\": \"3 mm\"}", "sku_disambiguator": "" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 20, "plate_height_mm": 6, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "door-soft-close-hinge-upgrade-kit-face-frame-half-overlay-10-door", "variant_sku": "DH-FF-HO-SC-20-6", "match_options_json": "{\"Pack Size\": \"20\", \"Plate Size\": \"6 mm\"}", "sku_disambiguator": "" },

    // -------- Slides: Side-mount singles --------
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 1, "product_handle": "drawer-glide-kit-frameless-euro-side-mount-single-pair", "variant_sku": "DG-FF-SM-FE-SC-18-1", "match_options_json": "{\"Pack Size\": \"Single\", \"Length\": \"18\\\"\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-18-1" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 1, "product_handle": "drawer-glide-kit-frameless-euro-side-mount-single-pair", "variant_sku": "DG-FF-SM-FE-SC-20-1", "match_options_json": "{\"Pack Size\": \"Single\", \"Length\": \"20\\\"\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-20-1" },

    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 1, "product_handle": "drawer-glide-kit-face-frame-side-mount-18-single-pair", "variant_sku": "DG-FF-SM-FE-SC-18-1", "match_options_json": "{\"Pack Size\": \"Single\", \"Length\": \"18\\\"\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-18-1" },
    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 1, "product_handle": "drawer-glide-kit-face-frame-side-mount-18-single-pair", "variant_sku": "DG-FF-SM-FE-SC-20-1", "match_options_json": "{\"Pack Size\": \"Single\", \"Length\": \"20\\\"\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-20-1" },

    // -------- Slides: Undermount packs --------
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 18, "pack_pairs": 4, "product_handle": "drawer-soft-close-glide-kit-frameless-undermount-full-extension-21-8-drawer", "variant_sku": "DG-FR-UM-FE-SC-21-8", "match_options_json": "{\"Pack Size\": \"4 pack\", \"Slide Length\": \"18\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-8" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 21, "pack_pairs": 4, "product_handle": "drawer-soft-close-glide-kit-frameless-undermount-full-extension-21-8-drawer", "variant_sku": "DG-FR-UM-FE-SC-21-9", "match_options_json": "{\"Pack Size\": \"4 pack\", \"Slide Length\": \"21\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-9" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 18, "pack_pairs": 8, "product_handle": "drawer-soft-close-glide-kit-frameless-undermount-full-extension-21-8-drawer", "variant_sku": "DG-FR-UM-FE-SC-21-10", "match_options_json": "{\"Pack Size\": \"8 pack\", \"Slide Length\": \"18\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-10" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 21, "pack_pairs": 8, "product_handle": "drawer-soft-close-glide-kit-frameless-undermount-full-extension-21-8-drawer", "variant_sku": "DG-FR-UM-FE-SC-21-11", "match_options_json": "{\"Pack Size\": \"8 pack\", \"Slide Length\": \"21\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-11" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 18, "pack_pairs": 12, "product_handle": "drawer-soft-close-glide-kit-frameless-undermount-full-extension-21-8-drawer", "variant_sku": "DG-FR-UM-FE-SC-21-12", "match_options_json": "{\"Pack Size\": \"12 pack\", \"Slide Length\": \"18\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-12" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 21, "pack_pairs": 12, "product_handle": "drawer-soft-close-glide-kit-frameless-undermount-full-extension-21-8-drawer", "variant_sku": "DG-FR-UM-FE-SC-21-13", "match_options_json": "{\"Pack Size\": \"12 pack\", \"Slide Length\": \"21\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-13" },

    // -------- Slides: Side-mount packs --------
    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 4, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FF-SM-FE-SC-18-4", "match_options_json": "{\"Package Size\": \"4 pack\", \"Cabinet Type\": \"Face Frame\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-18-4" },
    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 4, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FF-SM-FE-SC-20-4", "match_options_json": "{\"Package Size\": \"4 pack\", \"Cabinet Type\": \"Face Frame\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-20-4" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 4, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FR-SM-FE-SC-18-4", "match_options_json": "{\"Package Size\": \"4 pack\", \"Cabinet Type\": \"Euro/Frameless\"}", "sku_disambiguator": "DG-FR-SM-FE-SC-18-4" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 4, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FR-SM-FE-SC-20-4", "match_options_json": "{\"Package Size\": \"4 pack\", \"Cabinet Type\": \"Euro/Frameless\"}", "sku_disambiguator": "DG-FR-SM-FE-SC-20-4" },

    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 8, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FF-SM-FE-SC-18-8", "match_options_json": "{\"Package Size\": \"8 pack\", \"Cabinet Type\": \"Face Frame\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-18-8" },
    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 8, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FF-SM-FE-SC-20-8", "match_options_json": "{\"Package Size\": \"8 pack\", \"Cabinet Type\": \"Face Frame\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-20-8" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 8, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FR-SM-FE-SC-18-8", "match_options_json": "{\"Package Size\": \"8 pack\", \"Cabinet Type\": \"Euro/Frameless\"}", "sku_disambiguator": "DG-FR-SM-FE-SC-18-8" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 8, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FR-SM-FE-SC-20-8", "match_options_json": "{\"Package Size\": \"8 pack\", \"Cabinet Type\": \"Euro/Frameless\"}", "sku_disambiguator": "DG-FR-SM-FE-SC-20-8" },

    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 12, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FF-SM-FE-SC-18-12", "match_options_json": "{\"Package Size\": \"12 pack\", \"Cabinet Type\": \"Face Frame\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-18-12" },
    { "category": "slide_kit", "cabinet_type": "face_frame", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 12, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FF-SM-FE-SC-20-12", "match_options_json": "{\"Package Size\": \"12 pack\", \"Cabinet Type\": \"Face Frame\"}", "sku_disambiguator": "DG-FF-SM-FE-SC-20-12" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 18, "pack_pairs": 12, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FR-SM-FE-SC-18-12", "match_options_json": "{\"Package Size\": \"12 pack\", \"Cabinet Type\": \"Euro/Frameless\"}", "sku_disambiguator": "DG-FR-SM-FE-SC-18-12" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "side_mount", "slide_length_in": 20, "pack_pairs": 12, "product_handle": "drawer-soft-close-glide-kit-face-frame-side-mount-full-extension-21-4-drawer", "variant_sku": "DG-FR-SM-FE-SC-20-12", "match_options_json": "{\"Package Size\": \"12 pack\", \"Cabinet Type\": \"Euro/Frameless\"}", "sku_disambiguator": "DG-FR-SM-FE-SC-20-12" }
  ];

  // Extra rows: Undermount SINGLE pairs + Hinge SINGLE pairs
  var EXTRA_MATRIX_ROWS = [
    // Undermount SINGLEs (separate product handle)
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 18, "pack_pairs": 1, "product_handle": "dg-fr-um-fe-sc-21-1", "variant_sku": "DG-FR-UM-FE-SC-18-1", "match_options_json": "{\"Pack Size\": \"Single\", \"Slide Length\": \"18\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-18-1" },
    { "category": "slide_kit", "cabinet_type": "frameless", "door_style": "", "overlay_type": "", "pack_doors": "", "plate_height_mm": "", "slide_type": "undermount", "slide_length_in": 21, "pack_pairs": 1, "product_handle": "dg-fr-um-fe-sc-21-1", "variant_sku": "DG-FR-UM-FE-SC-21-1", "match_options_json": "{\"Pack Size\": \"Single\", \"Slide Length\": \"21\\\"\"}", "sku_disambiguator": "DG-FR-UM-FE-SC-21-1" },

    // Hinge SINGLEs (separate product handles)
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 1, "plate_height_mm": 0, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "dh-fr-eu-sc-1", "variant_sku": "DH-FR-EU-SC-1-0", "match_options_json": "{\"Plate Size\": \"0 mm\"}", "sku_disambiguator": "DH-FR-EU-SC-1-0" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 1, "plate_height_mm": 3, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "dh-fr-eu-sc-1", "variant_sku": "DH-FR-EU-SC-1-3", "match_options_json": "{\"Plate Size\": \"3 mm\"}", "sku_disambiguator": "DH-FR-EU-SC-1-3" },
    { "category": "hinge_kit", "cabinet_type": "frameless", "door_style": "overlay", "overlay_type": "euro_overlay", "pack_doors": 1, "plate_height_mm": 6, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "dh-fr-eu-sc-1", "variant_sku": "DH-FR-EU-SC-1-6", "match_options_json": "{\"Plate Size\": \"6 mm\"}", "sku_disambiguator": "DH-FR-EU-SC-1-6" },

    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 1, "plate_height_mm": 0, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "dh-ff-ho-sc-1", "variant_sku": "DH-FF-HO-SC-1-0", "match_options_json": "{\"Plate Size\": \"0 mm\"}", "sku_disambiguator": "DH-FF-HO-SC-1-0" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 1, "plate_height_mm": 3, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "dh-ff-ho-sc-1", "variant_sku": "DH-FF-HO-SC-1-3", "match_options_json": "{\"Plate Size\": \"3 mm\"}", "sku_disambiguator": "DH-FF-HO-SC-1-3" },
    { "category": "hinge_kit", "cabinet_type": "face_frame", "door_style": "overlay", "overlay_type": "half_overlay", "pack_doors": 1, "plate_height_mm": 6, "slide_type": "", "slide_length_in": "", "pack_pairs": "", "product_handle": "dh-ff-ho-sc-1", "variant_sku": "DH-FF-HO-SC-1-6", "match_options_json": "{\"Plate Size\": \"6 mm\"}", "sku_disambiguator": "DH-FF-HO-SC-1-6" }
  ];

  MATRIX = MATRIX.concat(EXTRA_MATRIX_ROWS);

  // -------------------------
  // DOM READY
  // -------------------------
  function onReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") setTimeout(fn, 0);
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    var el = document.getElementById("fitmentFinder");
    if (!el) return;

    // -------------------------
    // Helpers
    // -------------------------
    function h(tag, attrs, children) {
      attrs = attrs || {};
      children = children || [];
      var n = document.createElement(tag);
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (k === "class") n.className = v;
        else if (k === "html") n.innerHTML = v;
        else if (k === "checked") n.checked = !!v;
        else n.setAttribute(k, v);
      });
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c === null || c === undefined) return;
        if (typeof c === "string") n.appendChild(document.createTextNode(c));
        else n.appendChild(c);
      });
      return n;
    }

    function option(label, value) { return h("option", { value: value }, label); }
    function normalize(s) { return String(s || "").trim(); }

    // Robust inch parsing: handles 1/2", 1/2'', 20 in, 20″, etc.
    function parseInches(val) {
      var s = normalize(val);
      if (!s) return NaN;

      s = s
        .replace(/[″"]/g, "")
        .replace(/''/g, "")
        .replace(/inches?/gi, "")
        .replace(/\bin\b/gi, "")
        .replace(/[^\d\/\.\s-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      if (!s) return NaN;

      var mMixed = s.match(/^(\d+)\s+(\d+)\/(\d+)$/);
      if (mMixed) return (parseFloat(mMixed[1]) + (parseFloat(mMixed[2]) / parseFloat(mMixed[3])));

      var mFrac = s.match(/^(\d+)\/(\d+)$/);
      if (mFrac) return (parseFloat(mFrac[1]) / parseFloat(mFrac[2]));

      var n = parseFloat(s);
      return isFinite(n) ? n : NaN;
    }

    function canonOptionName(nm) {
      var s = normalize(nm).toLowerCase();
      if (s.indexOf("pack") >= 0 || s.indexOf("package") >= 0) return "pack";
      if (s.indexOf("plate") >= 0 || s.indexOf("mount") >= 0) return "plate";
      if (s.indexOf("length") >= 0 || s.indexOf("drawer") >= 0 || s.indexOf("slide") >= 0) return "length";
      if (s.indexOf("cabinet") >= 0) return "cabinet";
      return normalize(nm);
    }

    function matrixFind(criteria) {
      for (var i = 0; i < MATRIX.length; i++) {
        var r = MATRIX[i];
        var ok = true;
        for (var k in criteria) {
          if (!Object.prototype.hasOwnProperty.call(criteria, k)) continue;
          var v = criteria[k];
          if (v === "" || v === null || v === undefined) continue;
          if (String(r[k]) !== String(v)) { ok = false; break; }
        }
        if (ok) return r;
      }
      return null;
    }

    function money(cents) {
      var dollars = (cents || 0) / 100;
      return dollars.toLocaleString(undefined, { style: "currency", currency: "USD" });
    }

    function centsFromVariant(v) {
      var raw = (v && v.price != null) ? v.price : 0;
      var n = parseInt(String(raw).replace(/[^\d]/g, ""), 10);
      return isFinite(n) ? n : 0;
    }

    // -------------------------
    // META TRACKING (Pixel)
    // -------------------------
    function ffTrack(eventName, payload) {
      payload = payload || {};

      // Pixel
      if (typeof window.fbq === "function") {
        try {
          window.fbq("trackCustom", eventName, payload);

          // Mirror to standard events for better Meta reporting
          if (eventName === "ff_add_to_cart") window.fbq("track", "AddToCart", payload);
          if (eventName === "ff_start" || eventName === "ff_result") window.fbq("track", "ViewContent", payload);
        } catch (e) { }
      }

      // dataLayer (optional / harmless)
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        try { window.dataLayer.push({ event: eventName, ff: payload }); } catch (e2) { }
      }
    }

    // -------------------------
    // Suggest plate based on overlay (uses your ranges)
    // -------------------------
    function recommendHingePlateByOverlay(overlayIn) {
      return plateForOverlay(overlayIn);
    }

    function allowedSlideLengths(slideType) {
      return (slideType === "side_mount") ? ["18", "20"] : ["18", "21"];
    }

    function recommendSlideLengthFromDepth(slideType, drawerDepthIn) {
      var allowed = allowedSlideLengths(slideType).map(function (x) { return parseInt(x, 10); }).sort(function (a, b) { return a - b; });
      if (!isFinite(drawerDepthIn)) return null;
      var best = null;
      for (var i = 0; i < allowed.length; i++) if (allowed[i] <= drawerDepthIn) best = allowed[i];
      if (best === null) best = allowed[0];
      return String(best);
    }

    // -------------------------
    // Shopify fetch + variant resolve
    // -------------------------
    function fetchProduct(handle) {
      return fetch("/products/" + handle + ".js").then(function (res) {
        if (!res.ok) throw new Error("Could not load product details (" + handle + ").");
        return res.json();
      });
    }

    function findVariant(product, desiredOptions, skuDisambiguator) {
      var optionIndexByCanon = {};
      (product.options || []).forEach(function (o, idx) {
        optionIndexByCanon[canonOptionName(o.name)] = idx + 1;
      });

      var desired = desiredOptions || {};

      function matches(v) {
        for (var name in desired) {
          if (!Object.prototype.hasOwnProperty.call(desired, name)) continue;
          var val = desired[name];
          var key = canonOptionName(name);
          var wanted = normalize(val);
          var pos = optionIndexByCanon[key];
          if (!pos) continue; // if product doesn't have that option, ignore
          var got = normalize(v["option" + pos]);
          if (got !== wanted) return false;
        }
        if (skuDisambiguator) return normalize(v.sku) === normalize(skuDisambiguator);
        return true;
      }

      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i])) return variants[i];
      }
      return null;
    }

    function addMultipleToCart(items) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items.map(function (i) { return ({ id: i.variantId, quantity: i.qty }); }) })
      }).then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        return res.json();
      });
    }

    // -------------------------
    // PACKING LOGIC
    // -------------------------
    function planPacks(count, packSizes, minPackForPacks) {
      var n = parseInt(count, 10);
      if (!isFinite(n) || n <= 0) return null;

      if (n < minPackForPacks) {
        return { packs: [], singles: n };
      }

      var remaining = n;
      var packs = [];

      for (var i = 0; i < packSizes.length; i++) {
        var p = packSizes[i];
        if (remaining >= p) {
          var q = Math.floor(remaining / p);
          if (q > 0) {
            packs.push({ size: p, qty: q });
            remaining = remaining - (p * q);
          }
        }
      }

      return { packs: packs, singles: remaining };
    }

    function planHandlePacks(needed, addon) {
      var n = parseInt(needed, 10);
      if (!isFinite(n) || n <= 0) return null;
      if (!addon) return null;

      var have20 = !!(addon.pack20 && (addon.pack20.id || addon.pack20.sku));
      var have10 = !!(addon.pack10 && (addon.pack10.id || addon.pack10.sku));
      var haveSingle = !!(addon.single && (addon.single.id || addon.single.sku));

      // no packs => singles-only
      if (!have20 && !have10) {
        if (!haveSingle) return null;
        return { packs: [], singles: n, note: "Singles only" };
      }

      var packSizes = [];
      if (have20) packSizes.push(20);
      if (have10) packSizes.push(10);

      // Same hinge rule: <10 => singles-only (if singles exist)
      if (n < 10) {
        if (haveSingle) return { packs: [], singles: n, note: "Singles only (under 10)" };
        var smallestU10 = packSizes[packSizes.length - 1];
        return { packs: [{ size: smallestU10, qty: 1 }], singles: 0, note: "Rounded up (no singles available)" };
      }

      var plan = planPacks(n, packSizes, 10);
      if (!plan) return null;

      // remainder
      if (plan.singles > 0 && !haveSingle) {
        var smallest = packSizes[packSizes.length - 1];
        plan.packs.push({ size: smallest, qty: 1 });
        plan.singles = 0;
        plan.note = "Rounded up to full pack (no singles available)";
      } else {
        plan.note = "";
      }

      return plan;
    }

    // -------------------------
    // UI Render
    // -------------------------
    function render() {
      var defaultAddonKey = (HANDLE_ADDONS && HANDLE_ADDONS[0] && HANDLE_ADDONS[0].key) ? HANDLE_ADDONS[0].key : "";

      var state = {
        mode: "hinge",         // hinge | slide | both
        cabinet: "face_frame", // face_frame | frameless

        overlayInput: "",
        doorThicknessInput: "",
        doorWidthInput: "",
        openingWidthInput: "",
        plate: "0",
        doorsCountInput: "",

        slideType: "side_mount",
        slideLen: "18",
        drawersCountInput: "",
        drawerDepthInput: "",
        cabinetDepthInput: "",

        // handles add-on
        addHandles: false,
        handleAddonKey: defaultAddonKey,
        handlesNeededInput: "",

        // accessories
        accessorySelections: {
          screws100: false,
          ffJig: false
        }
      };

      var statusLine = h("div", { class: "ff-sub", id: "ffStatus" }, 'Answer a few quick questions, then click "Find my match".');
      var resultBox = h("div", { id: "ffResult" });

      var modeSel = h("select", { class: "ff-select" }, [
        option("Hinges (soft-close upgrade)", "hinge"),
        option("Drawer slides / glides (soft-close)", "slide"),
        option("Both (hinges + drawer slides)", "both")
      ]);
      modeSel.value = state.mode;

      var cabSel = h("select", { class: "ff-select" }, [
        option("Face-frame (frame around opening)", "face_frame"),
        option("Frameless / Euro (no face frame)", "frameless")
      ]);
      cabSel.value = state.cabinet;

      // Hinge controls
      var overlayInp = h("input", { class: "ff-input", inputmode: "decimal", placeholder: 'Example: 1/2  or  0.5  or  5/8  (inch marks like " are OK)' });
      var doorThkInp = h("input", { class: "ff-input", inputmode: "decimal", placeholder: "Optional (example: 3/4)" });
      var doorsCountInp = h("input", { class: "ff-input", inputmode: "numeric", placeholder: "Optional (example: 37)" });

      var doorWidthInp = h("input", { class: "ff-input", inputmode: "decimal", placeholder: "Optional (example: 17 7/8)" });
      var openingWidthInp = h("input", { class: "ff-input", inputmode: "decimal", placeholder: "Optional (example: 16 1/2)" });
      var calcOverlayBtn = h("button", { class: "ff-btn secondary", type: "button", style: "padding:10px 12px;max-width:320px;" }, "Calculate overlay from widths");

      var plateSel = h("select", { class: "ff-select" }, [option("0 mm", "0"), option("3 mm", "3"), option("6 mm", "6")]);
      plateSel.value = state.plate;

      var overlayWarn = h("div", { class: "ff-note ff-danger", style: "display:none;" });
      var overlayHint = h("div", { class: "ff-note ff-warn", style: "display:none;" });
      var plateHint = h("div", { class: "ff-note", style: "display:none;" });
      var confidenceNote = h("div", { class: "ff-note", style: "display:none;" });
      var overlayCalcNote = h("div", { class: "ff-note", style: "display:none;" });

      var overlayDetails = h("details", {}, [
        h("summary", {}, "How to measure door overlay (quick)"),
        h("div", { class: "ff-sub", style: "margin-top:8px;" }, [
          "Open the door. Measure how much the door overlaps the cabinet opening (or face frame) on the hinge side. That distance is your overlay."
        ])
      ]);

      var compactHingeNote = h("div", { class: "ff-note ff-danger", style: "display:none;margin-top:10px;" }, [
        h("div", { style: "font-weight:900;" }, 'Overlay over 3/4" needs a different hinge style.'),
        h("div", { class: "ff-sub" }, "Anything over 3/4 overlay typically requires special compact hinges or different plate/arm geometry."),
        h("a", { href: CONTACT_URL, class: "ff-link", style: "font-weight:900;display:inline-block;margin-top:8px;" }, "Inquire further (Contact Us)")
      ]);

      // Slide controls
      var slideTypeSel = h("select", { class: "ff-select" }, [
        option("Side-mount (visible on drawer side)", "side_mount"),
        option("Undermount (hidden under drawer)", "undermount")
      ]);
      slideTypeSel.value = state.slideType;

      var drawerDepthInp = h("input", { class: "ff-input", inputmode: "decimal", placeholder: "Example: 20  (drawer box depth)" });
      var cabinetDepthInp = h("input", { class: "ff-input", inputmode: "decimal", placeholder: "Optional: interior cabinet depth" });
      var drawersCountInp = h("input", { class: "ff-input", inputmode: "numeric", placeholder: "Optional (example: 7)" });

      var slideLenSel = h("select", { class: "ff-select" }, [
        option('18"', "18"),
        option('20"', "20"),
        option('21"', "21")
      ]);
      slideLenSel.value = state.slideLen;

      var undermountInfo = h("div", { class: "ff-note", style: "display:none;" }, [
        h("div", { style: "font-weight:900;" }, "Undermount fitment checklist"),
        h("div", { class: "ff-sub" }, "Undermount systems require specific drawer prep. Confirm these before ordering:"),
        h("ul", { style: "margin:8px 0 0 18px;color:#0f172a;" }, [
          h("li", {}, "Rear notches and/or drilled holes at the back to engage hooks/pins."),
          h("li", {}, "Front locking devices (mounting clips) installed under front corners."),
          h("li", {}, "Accurate drawer width tolerance."),
          h("li", {}, "Clearance under the drawer (some drawers need a bottom recess).")
        ]),
        h("div", { class: "ff-sub", style: "margin-top:8px;" }, "If you’re unsure, contact us before ordering and we’ll help you match the correct system."),
        h("a", { href: CONTACT_URL, class: "ff-link", style: "font-weight:900;display:inline-block;margin-top:6px;" }, "Contact Us for help")
      ]);

      var undermountCabWarn = h("div", { class: "ff-note ff-warn", style: "display:none;" }, [
        h("div", { style: "font-weight:900;" }, "Face-frame + undermount note"),
        h("div", { class: "ff-sub" }, "Undermount hardware here is listed for frameless/Euro applications. Face-frame undermount typically needs brackets or a different setup.")
      ]);

      var slideWarn = h("div", { class: "ff-note ff-warn", style: "display:none;" });

      // Handles add-on controls
      var addHandlesChk = h("input", { type: "checkbox", checked: false });
      var handleSel = h("select", { class: "ff-select" }, (HANDLE_ADDONS || []).map(function (a) { return option(a.label, a.key); }));
      handleSel.value = state.handleAddonKey;

      var handlesNeededInp = h("input", { class: "ff-input", inputmode: "numeric", placeholder: "Optional (example: 24)" });

      var handlesReco = h("div", { class: "ff-note", style: "display:none;" });
      var useRecoBtn = h("button", { class: "ff-btn secondary", type: "button", style: "padding:10px 12px;max-width:320px;" }, "Use this number");
      var handlesHint = h("div", { class: "ff-note", style: "display:none;" });

      // Main button
      var btn = h("button", { class: "ff-btn", type: "button" }, "Find my match");

      function selectedHandleAddon() {
        for (var i = 0; i < HANDLE_ADDONS.length; i++) {
          if (HANDLE_ADDONS[i].key === state.handleAddonKey) return HANDLE_ADDONS[i];
        }
        return HANDLE_ADDONS[0] || null;
      }

      function inferredPullCount() {
        var doors = parseInt(state.doorsCountInput, 10);
        var drawers = parseInt(state.drawersCountInput, 10);
        var d = isFinite(doors) ? doors : 0;
        var r = isFinite(drawers) ? drawers : 0;
        var total = d + r;
        return { doors: isFinite(doors) ? doors : null, drawers: isFinite(drawers) ? drawers : null, total: total > 0 ? total : 0 };
      }

      function updateHandlesRecommendationUI() {
        if (!state.addHandles) { handlesReco.style.display = "none"; return; }
        var inf = inferredPullCount();
        if (!inf.total) { handlesReco.style.display = "none"; return; }

        var parts = [];
        if (inf.doors !== null) parts.push("Doors: <strong>" + inf.doors + "</strong>");
        if (inf.drawers !== null) parts.push("Drawers: <strong>" + inf.drawers + "</strong>");
        var calc = parts.length ? (parts.join(" + ") + " = <strong>" + inf.total + "</strong> pulls") : ("<strong>" + inf.total + "</strong> pulls");

        handlesReco.style.display = "";
        handlesReco.innerHTML =
          '<div style="font-weight:900;">Recommended handle count</div>' +
          '<div class="ff-sub">Quick rule: <strong>doors + drawers = total pulls</strong>. Based on what you entered: ' + calc + ".</div>";

        if (!handlesReco.contains(useRecoBtn)) {
          handlesReco.appendChild(h("div", { style: "margin-top:10px;" }, useRecoBtn));
        }
      }

      function makeBreakdownText(plan, packWord) {
        if (!plan) return "";
        packWord = packWord || "pack";
        var parts = [];
        for (var i = 0; i < plan.packs.length; i++) {
          parts.push(plan.packs[i].qty + " × " + plan.packs[i].size + "-" + packWord);
        }
        if (plan.singles) parts.push(plan.singles + " singles");
        return parts.join(" + ");
      }

      function updateHandlesSuggestion() {
        if (!state.addHandles) { handlesHint.style.display = "none"; return; }

        var addon = selectedHandleAddon();
        if (!addon) { handlesHint.style.display = "none"; return; }

        var inf = inferredPullCount();
        var entered = parseInt(state.handlesNeededInput, 10);
        var hasEntered = isFinite(entered) && entered > 0;
        var needed = hasEntered ? entered : (inf.total || 0);

        if (!needed) { handlesHint.style.display = "none"; return; }

        var plan = planHandlePacks(needed, addon);
        if (!plan) {
          handlesHint.style.display = "";
          handlesHint.innerHTML =
            '<div style="font-weight:900;">Handles add-on</div>' +
            '<div class="ff-sub">This handle option isn’t fully configured for packing (missing variants). Please contact us.</div>';
          return;
        }

        handlesHint.style.display = "";
        handlesHint.innerHTML =
          '<div style="font-weight:900;">Handles pack breakdown</div>' +
          '<div class="ff-sub">We’ll build your handles as: <strong>' + makeBreakdownText(plan, "pack") + "</strong>.</div>" +
          (plan.note ? ('<div class="ff-kicker">' + plan.note + '</div>') : '');
      }

      function buildSummaryBox(lines) {
        var total = 0;
        for (var i = 0; i < lines.length; i++) total += (lines[i].centsEach * lines[i].qty);

        return h("div", { class: "ff-note" }, [
          h("div", { style: "font-weight:900;" }, "Bundle summary"),
          h("div", { class: "ff-sub" }, "Review what will be added to your cart:"),
          h("div", { class: "ff-summary" }, [
            h("div", { class: "ff-srow ff-shead" }, [
              h("div", {}, "Item"),
              h("div", {}, "SKU"),
              h("div", {}, "Qty"),
              h("div", { class: "ff-sright" }, "Est. Total")
            ])
          ].concat(lines.map(function (l) {
            return h("div", { class: "ff-srow" }, [
              h("div", { class: "ff-scell" }, [
                h("div", { class: "ff-sitem" }, [
                  h("span", {}, l.label)
                ].concat((l.pills || []).map(function (p) { return h("span", { class: "ff-pill" }, p); }))),
                l.link ? h("div", { class: "ff-kicker" }, [h("a", { class: "ff-link", href: l.link }, "View details")]) : null
              ]),
              h("div", { class: "ff-scell" }, l.sku || "—"),
              h("div", { class: "ff-scell" }, String(l.qty)),
              h("div", { class: "ff-scell ff-sright" }, money(l.centsEach * l.qty))
            ]);
          }))),

          h("div", { class: "ff-hr" }),
          h("div", { class: "ff-inline" }, [
            h("div", { style: "font-weight:900;" }, "Estimated bundle total"),
            h("div", { style: "font-weight:900;text-align:right;" }, money(total))
          ]),
          h("div", { class: "ff-kicker" }, "Estimated total shown before tax and shipping.")
        ]);
      }

      function resolveMatrixRow(criteria) {
        var row = matrixFind(criteria);
        if (!row) throw new Error("No match found for the packing breakdown. (Missing matrix row: " + JSON.stringify(criteria) + ")");
        return row;
      }

      function resolveItemFromRow(row) {
        var desiredOptions = row.match_options_json ? JSON.parse(row.match_options_json) : {};
        return fetchProduct(row.product_handle).then(function (product) {
          var skuTie = row.sku_disambiguator || row.variant_sku || "";
          var variant = findVariant(product, desiredOptions, skuTie);
          if (!variant) throw new Error("Found product, but couldn't match variant. Check option labels/values and SKUs.");
          return { row: row, product: product, variant: variant };
        });
      }

      function resolveAccessories(state) {
        var selected = [];
        for (var i = 0; i < ACCESSORY_ADDONS.length; i++) {
          var a = ACCESSORY_ADDONS[i];
          if (!a.showIf(state)) continue;
          if (!state.accessorySelections[a.key]) continue;
          selected.push(a);
        }
        if (!selected.length) return Promise.resolve([]);

        return Promise.all(selected.map(function (a) {
          return fetchProduct(a.handle).then(function (product) {
            var variant = (product.variants && product.variants[0]) ? product.variants[0] : null;
            if (!variant) throw new Error("Could not load accessory: " + a.handle);
            return { kind: "accessory", addon: a, product: product, variant: variant, qty: a.defaultQty || 1 };
          });
        }));
      }

      function resolveHandleAddons() {
        if (!state.addHandles) return Promise.resolve([]);

        var addon = selectedHandleAddon();
        if (!addon) throw new Error("Handle add-on enabled but not configured.");

        var inf = inferredPullCount();
        var entered = parseInt(state.handlesNeededInput, 10);
        var needed = (isFinite(entered) && entered > 0) ? entered : (inf.total || 0);
        if (!needed) return Promise.resolve([]);

        var plan = planHandlePacks(needed, addon);
        if (!plan) throw new Error("Handle add-on is missing the required variants (single/10-pack/20-pack).");

        var lines = [];

        // Packs (20 / 10)
        for (var i = 0; i < plan.packs.length; i++) {
          var p = plan.packs[i];
          var vi = (p.size === 20) ? addon.pack20 : addon.pack10;
          if (!vi || (!vi.id && !vi.sku)) continue;
          lines.push({ qty: p.qty, packSize: p.size, variantId: vi.id || null, sku: vi.sku || "" });
        }

        // Singles
        if (plan.singles && addon.single && (addon.single.id || addon.single.sku)) {
          lines.push({ qty: plan.singles, packSize: 1, variantId: addon.single.id || null, sku: addon.single.sku || "" });
        }

        if (!lines.length) return Promise.resolve([]);

        function findVariantByIdOrSku(product, id, sku) {
          var variants = product.variants || [];
          if (id) {
            for (var a = 0; a < variants.length; a++) {
              if (String(variants[a].id) === String(id)) return variants[a];
            }
          }
          if (sku) {
            var wanted = normalize(sku);
            for (var b = 0; b < variants.length; b++) {
              if (normalize(variants[b].sku) === wanted) return variants[b];
            }
          }
          return null;
        }

        return fetchProduct(addon.product_handle).then(function (product) {
          return lines.map(function (li) {
            var variant = findVariantByIdOrSku(product, li.variantId, li.sku);
            if (!variant) throw new Error("Could not match handle variant (check SKU/variant id): " + (li.sku || li.variantId));
            return { kind: "handles", addon: addon, product: product, variant: variant, qty: li.qty };
          });
        });
      }

      function resolveHingesByCount() {
        var n = parseInt(state.doorsCountInput, 10);
        if (!isFinite(n) || n <= 0) return Promise.resolve([]);

        var overlayIn = parseInches(state.overlayInput);
        if (isFinite(overlayIn) && overlayIn > 0.75) {
          throw new Error('Overlay over 3/4" typically needs a compact hinge style. Please contact us to match the correct hardware.');
        }

        var plan = planPacks(n, [20, 10], 10);
        if (!plan) return Promise.resolve([]);

        var items = [];
        plan.packs.forEach(function (p) { items.push({ pack_doors: p.size, qty: p.qty }); });
        if (plan.singles) items.push({ pack_doors: 1, qty: plan.singles });

        return Promise.all(items.map(function (it) {
          var row = resolveMatrixRow({
            category: "hinge_kit",
            cabinet_type: state.cabinet,
            pack_doors: it.pack_doors,
            plate_height_mm: state.plate
          });
          return resolveItemFromRow(row).then(function (x) {
            return { kind: "hinge", row: x.row, product: x.product, variant: x.variant, qty: it.qty };
          });
        }));
      }

      function resolveSlidesByCount() {
        var n = parseInt(state.drawersCountInput, 10);
        if (!isFinite(n) || n <= 0) return Promise.resolve([]);

        if (state.slideType === "undermount" && state.cabinet === "face_frame") {
          throw new Error("Undermount kits here are listed for frameless/Euro. Face-frame undermount usually needs brackets or a different setup—contact us and we’ll match the correct parts.");
        }

        var plan = planPacks(n, [12, 8, 4], 4);
        if (!plan) return Promise.resolve([]);

        var items = [];
        plan.packs.forEach(function (p) { items.push({ pack_pairs: p.size, qty: p.qty }); });
        if (plan.singles) items.push({ pack_pairs: 1, qty: plan.singles });

        return Promise.all(items.map(function (it) {
          var row = resolveMatrixRow({
            category: "slide_kit",
            slide_type: state.slideType,
            cabinet_type: state.cabinet,
            slide_length_in: state.slideLen,
            pack_pairs: it.pack_pairs
          });
          return resolveItemFromRow(row).then(function (x) {
            return { kind: "slide", row: x.row, product: x.product, variant: x.variant, qty: it.qty };
          });
        }));
      }

      // ---- Meta "start" event (first meaningful interaction) ----
      var didStart = false;
      function markStart() {
        if (didStart) return;
        didStart = true;
        ffTrack("ff_start", {
          mode: state.mode,
          cabinet: state.cabinet,
          slideType: state.slideType,
          slideLen: state.slideLen
        });
      }

      function onFind() {
        btn.disabled = true;
        statusLine.textContent = "Working…";
        resultBox.innerHTML = "";

        markStart();

        var wantsHinges = (state.mode === "hinge" || state.mode === "both");
        var wantsSlides = (state.mode === "slide" || state.mode === "both");

        var hingePromise = wantsHinges ? Promise.resolve().then(resolveHingesByCount) : Promise.resolve([]);
        var slidePromise = wantsSlides ? Promise.resolve().then(resolveSlidesByCount) : Promise.resolve([]);

        Promise.all([hingePromise, slidePromise])
          .then(function (pairs) {
            var hingeMatches = pairs[0] || [];
            var slideMatches = pairs[1] || [];

            return resolveHandleAddons()
              .then(function (handleMatches) {
                return resolveAccessories(state).then(function (accMatches) {
                  var matches = hingeMatches.concat(slideMatches);
                  (handleMatches || []).forEach(function (hm) { matches.push(hm); });
                  matches = matches.concat(accMatches || []);

                  if (!matches.length) {
                    throw new Error("Enter door and/or drawer quantities so we can build the pack + singles breakdown.");
                  }

                  var lines = matches.map(function (m) {
                    var sku = (m.variant && m.variant.sku) || (m.row && m.row.variant_sku) || "";
                    var centsEach = centsFromVariant(m.variant);
                    var handle = (m.product && m.product.handle) || (m.row && m.row.product_handle) || (m.addon && (m.addon.product_handle || m.addon.handle)) || "";
                    var link = (handle && m.variant && m.variant.id) ? ("/products/" + handle + "?variant=" + m.variant.id) : "";
                    var label = (m.product && m.product.title) ? m.product.title : "Item";

                    var pills = [];
                    if (m.kind === "hinge") pills.push("Hinges");
                    if (m.kind === "slide") pills.push(m.row && m.row.slide_type === "undermount" ? "Undermount" : "Slides");
                    if (m.kind === "handles") pills.push("Handles");
                    if (m.kind === "accessory") pills.push("Accessory");

                    return { label: label, sku: sku, qty: m.qty, centsEach: centsEach, link: link, pills: pills };
                  });

                  // ---- Meta: result event (includes selection + items) ----
                  ffTrack("ff_result", {
                    mode: state.mode,
                    cabinet: state.cabinet,
                    slideType: state.slideType,
                    slideLen: state.slideLen,
                    doors: parseInt(state.doorsCountInput, 10) || 0,
                    drawers: parseInt(state.drawersCountInput, 10) || 0,
                    addHandles: !!state.addHandles,
                    items: (lines || []).map(function (l) { return { sku: l.sku || "", qty: l.qty }; })
                  });

                  resultBox.appendChild(buildSummaryBox(lines));

                  // ---- Lead fallback CTA under results (prefilled) + Meta Lead ----
                  var qs = [];
                  qs.push("mode=" + encodeURIComponent(state.mode));
                  qs.push("cabinet=" + encodeURIComponent(state.cabinet));
                  qs.push("slideType=" + encodeURIComponent(state.slideType));
                  qs.push("slideLen=" + encodeURIComponent(state.slideLen));
                  qs.push("overlay=" + encodeURIComponent(state.overlayInput || ""));
                  qs.push("plate=" + encodeURIComponent(state.plate || ""));
                  qs.push("doors=" + encodeURIComponent(state.doorsCountInput || ""));
                  qs.push("drawerDepth=" + encodeURIComponent(state.drawerDepthInput || ""));
                  qs.push("drawers=" + encodeURIComponent(state.drawersCountInput || ""));
                  qs.push("addHandles=" + encodeURIComponent(String(!!state.addHandles)));
                  qs.push("handlesNeeded=" + encodeURIComponent(state.handlesNeededInput || ""));
                  qs.push("items=" + encodeURIComponent(JSON.stringify((lines || []).map(function (l) {
                    return { sku: l.sku || "", qty: l.qty };
                  }))));

                  var reviewUrl = CONTACT_URL + (CONTACT_URL.indexOf("?") >= 0 ? "&" : "?") + qs.join("&");

                  var reviewCard = h("div", { class: "ff-note", style: "margin-top:10px;" }, [
                    h("div", { style: "font-weight:900;" }, "Not 100% sure?"),
                    h("div", { class: "ff-sub" }, "Send us your selections and we’ll confirm the match before you order."),
                    h("a", {
                      class: "ff-btn secondary",
                      href: reviewUrl,
                      style: "display:inline-block;max-width:420px;margin-top:10px;text-align:center;text-decoration:none;"
                    }, "Get match review")
                  ]);

                  reviewCard.querySelector("a").addEventListener("click", function () {
                    ffTrack("ff_lead_click", {
                      mode: state.mode,
                      cabinet: state.cabinet,
                      slideType: state.slideType,
                      slideLen: state.slideLen
                    });
                    if (typeof window.fbq === "function") {
                      try { window.fbq("track", "Lead"); } catch (e) { }
                    }
                  });

                  resultBox.appendChild(reviewCard);

                  // Add-to-cart button
                  var addLabel = "Add to cart";
                  if (state.mode === "both") addLabel = "Add bundle to cart";
                  if (state.addHandles) addLabel = (state.mode === "both") ? "Add bundle + handles to cart" : "Add kit + handles to cart";

                  var addBtn = h("button", { class: "ff-btn", type: "button", style: "margin-top:10px;" }, addLabel);
                  addBtn.addEventListener("click", function () {
                    addBtn.disabled = true;

                    var items = matches.map(function (m) { return ({ variantId: m.variant.id, qty: m.qty }); });

                    // ---- Meta: add value + currency (estimated) ----
                    var totalCents = (lines || []).reduce(function (sum, l) { return sum + (l.centsEach * l.qty); }, 0);
                    var totalValue = Math.round(totalCents) / 100;

                    ffTrack("ff_add_to_cart", {
                      mode: state.mode,
                      cabinet: state.cabinet,
                      slideType: state.slideType,
                      slideLen: state.slideLen,
                      doors: parseInt(state.doorsCountInput, 10) || 0,
                      drawers: parseInt(state.drawersCountInput, 10) || 0,
                      addHandles: !!state.addHandles,
                      value: totalValue,
                      currency: "USD",
                      items: (lines || []).map(function (l) {
                        return { sku: l.sku || "", qty: l.qty, est: (l.centsEach * l.qty) };
                      })
                    });

                    addMultipleToCart(items).then(function () {
                      window.location.href = "/cart";
                    }).catch(function (e) {
                      addBtn.disabled = false;
                      alert(e && e.message ? e.message : String(e));
                    });
                  });
                  resultBox.appendChild(addBtn);

                  statusLine.textContent = "Done.";
                });
              });
          })
          .catch(function (e) {
            statusLine.textContent = "We couldn’t confirm a safe match.";
            resultBox.innerHTML =
              '<div class="ff-note ff-danger">' +
              '<div style="font-weight:900;margin-bottom:6px;">' + (e && e.message ? e.message : String(e)) + "</div>" +
              '<div class="ff-sub">Use the contact button below and we’ll help you match the correct hardware.</div>' +
              '<a class="ff-link" style="font-weight:900;" href="' + CONTACT_URL + '">Contact Us</a>' +
              "</div>";
          })
          .finally(function () {
            btn.disabled = false;
          });
      }

      function refresh() {
        var showHinges = (state.mode === "hinge" || state.mode === "both");
        var showSlides = (state.mode === "slide" || state.mode === "both");

        hingeBox.style.display = showHinges ? "" : "none";
        slideBox.style.display = showSlides ? "" : "none";

        btn.textContent = (state.mode === "both") ? "Find my matches" : "Find my match";

        var allowed = allowedSlideLengths(state.slideType);
        Array.prototype.forEach.call(slideLenSel.options, function (o) { o.disabled = (allowed.indexOf(o.value) === -1); });
        if (allowed.indexOf(state.slideLen) === -1) {
          state.slideLen = allowed[0];
          slideLenSel.value = state.slideLen;
        }

        undermountInfo.style.display = (showSlides && state.slideType === "undermount") ? "" : "none";

        if (state.mode === "slide" && state.slideType === "undermount") {
          cabSel.value = "frameless";
          cabSel.disabled = true;
          state.cabinet = "frameless";
        } else {
          cabSel.disabled = false;
        }

        undermountCabWarn.style.display = (showSlides && state.slideType === "undermount" && state.cabinet === "face_frame") ? "" : "none";

        // -------- Overlay + Plate ranges + Confidence --------
        var overlayIn = parseInches(state.overlayInput);
        overlayWarn.style.display = "none";
        overlayHint.style.display = "none";
        compactHingeNote.style.display = "none";
        plateHint.style.display = "none";
        confidenceNote.style.display = "none";

        if (showHinges) {
          if (isFinite(overlayIn)) {
            if (overlayIn > 0.75) {
              compactHingeNote.style.display = "";
            } else {
              var matchedPlate = plateForOverlay(overlayIn);
              var conf = confidenceForPlate(overlayIn, state.plate);
              var lvl = conf ? conf.level : "warn";
              var col = (lvl === "good") ? "rgb(22,163,74)" : (lvl === "warn") ? "rgb(217,119,6)" : "rgb(220,38,38)";

              overlayHint.style.display = "";
              overlayHint.innerHTML =
                '<div style="font-weight:900;">Overlay entered: <span style="color:' + col + ';">' +
                overlayIn.toFixed(3).replace(/\.0+$/, "") + "&quot;</span></div>" +
                '<div class="ff-sub">Matching plate range is highlighted below. Safest option is still matching the plate height already installed.</div>';

              function rangeCard(plateKey) {
                var r = PLATE_RANGES[plateKey];
                var isMatch = (String(plateKey) === String(matchedPlate));
                var bg = isMatch ? "rgba(22,163,74,.08)" : "rgba(148,163,184,.08)";
                var br = isMatch ? "rgba(22,163,74,.45)" : "rgba(148,163,184,.22)";
                var txt = isMatch ? "rgb(22,163,74)" : "inherit";
                return (
                  '<div class="ff-range" style="border:1px solid ' + br + ';background:' + bg + ';border-radius:12px;padding:10px 10px;">' +
                  '<div style="font-weight:900;color:' + txt + ';">' + plateKey + ' mm</div>' +
                  '<div class="ff-kicker" style="margin-top:2px;">' + r.label + '</div>' +
                  '</div>'
                );
              }

              var selectedMatches = (String(state.plate) === String(matchedPlate));
              var selCol = selectedMatches ? "rgb(22,163,74)" : "rgb(217,119,6)";

              plateHint.style.display = "";
              plateHint.innerHTML =
                '<div style="font-weight:900;">Overlay-to-plate ranges</div>' +
                '<div class="ff-rangegrid">' +
                rangeCard("0") + rangeCard("3") + rangeCard("6") +
                '</div>' +
                '<div class="ff-kicker" style="margin-top:8px;">Selected plate: <strong style="color:' + selCol + ';">' +
                state.plate + ' mm</strong>' +
                (selectedMatches ? ' (matches overlay)' : ' (does not match overlay)') +
                '</div>';

              if (conf) {
                confidenceNote.style.display = "";
                confidenceNote.innerHTML =
                  '<div style="font-weight:900;">Fit confidence: <span style="color:' + col + ';">' + conf.label + '</span></div>' +
                  '<div class="ff-sub">Based on your overlay vs the <strong>' + state.plate + ' mm</strong> plate range.</div>';
              }
            }
          } else if (normalize(state.overlayInput)) {
            overlayWarn.style.display = "";
            overlayWarn.innerHTML =
              '<div style="font-weight:900;">Couldn’t read that overlay value.</div>' +
              '<div class="ff-sub">Try 1/4, 1/2, 5/8, or 0.5. Inch marks like " or \'\' are OK.</div>';
          }
        }

        // overlay from widths
        var dw = parseInches(state.doorWidthInput);
        var ow = parseInches(state.openingWidthInput);
        if (showHinges && isFinite(dw) && isFinite(ow) && dw > ow) {
          var calc = (dw - ow) / 2;
          overlayCalcNote.style.display = "";
          overlayCalcNote.innerHTML =
            '<div style="font-weight:900;">Calculated overlay (from widths): ' + calc.toFixed(3).replace(/\.0+$/, "") + "&quot; per side</div>" +
            '<div class="ff-sub">Helpful estimate. Final overlay should be confirmed on the hinge side.</div>';
        } else {
          overlayCalcNote.style.display = "none";
        }

        // slide recs
        slideWarn.style.display = "none";
        if (showSlides && normalize(state.drawerDepthInput)) {
          var depthIn = parseInches(state.drawerDepthInput);
          if (!isFinite(depthIn)) {
            slideWarn.style.display = "";
            slideWarn.innerHTML = '<div style="font-weight:900;">Couldn’t read that drawer depth.</div><div class="ff-sub">Try 20 or 20 1/2.</div>';
          } else {
            var recLen = recommendSlideLengthFromDepth(state.slideType, depthIn);
            if (recLen) {
              slideWarn.style.display = "";
              slideWarn.innerHTML =
                '<div style="font-weight:900;">Suggested slide length: ' + recLen + "&quot;</div>" +
                "<div class='ff-sub'>Based on your drawer depth. Always confirm your product supports that length.</div>";
            }
          }
        }

        // handles section
        addOnInner.style.display = state.addHandles ? "" : "none";
        updateHandlesRecommendationUI();
        updateHandlesSuggestion();

        // accessories visibility
        ACCESSORY_ADDONS.forEach(function (a) {
          var ui = accessoryUI[a.key];
          if (!ui) return;
          var visible = a.showIf(state);
          ui.wrap.style.display = visible ? "flex" : "none";
          ui.chk.checked = !!state.accessorySelections[a.key];
        });

        // show pack breakdown hints
        hingeBreakdown.style.display = "none";
        slideBreakdown.style.display = "none";

        var dn = parseInt(state.doorsCountInput, 10);
        if (showHinges && isFinite(dn) && dn > 0) {
          var hp = planPacks(dn, [20, 10], 10);
          if (hp) {
            hingeBreakdown.style.display = "";
            hingeBreakdown.innerHTML =
              '<div style="font-weight:900;">Pack breakdown</div>' +
              '<div class="ff-sub">We’ll build your hinges as: <strong>' + makeBreakdownText(hp, "pack") + "</strong> (packs + singles)</div>";
          }
        }

        var rn = parseInt(state.drawersCountInput, 10);
        if (showSlides && isFinite(rn) && rn > 0) {
          var sp = planPacks(rn, [12, 8, 4], 4);
          if (sp) {
            slideBreakdown.style.display = "";
            slideBreakdown.innerHTML =
              '<div style="font-weight:900;">Pack breakdown</div>' +
              '<div class="ff-sub">We’ll build your slides as: <strong>' + makeBreakdownText(sp, "pack") + "</strong> (packs + singles)</div>";
          }
        }
      }

      // Events → mark start on meaningful interactions
      function bindStart(elm) {
        if (!elm || !elm.addEventListener) return;
        elm.addEventListener("input", markStart);
        elm.addEventListener("change", markStart);
      }

      modeSel.addEventListener("change", function () { state.mode = modeSel.value; refresh(); });
      cabSel.addEventListener("change", function () { state.cabinet = cabSel.value; refresh(); });

      overlayInp.addEventListener("input", function () {
        state.overlayInput = overlayInp.value;
        var overlayIn = parseInches(state.overlayInput);
        var suggestedPlate = recommendHingePlateByOverlay(overlayIn);
        if (suggestedPlate) { plateSel.value = suggestedPlate; state.plate = suggestedPlate; }
        refresh();
      });

      doorThkInp.addEventListener("input", function () { state.doorThicknessInput = doorThkInp.value; refresh(); });
      doorWidthInp.addEventListener("input", function () { state.doorWidthInput = doorWidthInp.value; refresh(); });
      openingWidthInp.addEventListener("input", function () { state.openingWidthInput = openingWidthInp.value; refresh(); });

      calcOverlayBtn.addEventListener("click", function () {
        var dw = parseInches(state.doorWidthInput);
        var ow = parseInches(state.openingWidthInput);
        if (!isFinite(dw) || !isFinite(ow) || dw <= ow) {
          alert("Please enter a valid Door Width and Opening Width (door must be wider than opening).");
          return;
        }
        var overlay = (dw - ow) / 2;
        var val = overlay.toFixed(3).replace(/\.0+$/, "");
        overlayInp.value = val;
        state.overlayInput = val;
        var suggestedPlate = recommendHingePlateByOverlay(overlay);
        if (suggestedPlate) { plateSel.value = suggestedPlate; state.plate = suggestedPlate; }
        refresh();
      });

      doorsCountInp.addEventListener("input", function () { state.doorsCountInput = doorsCountInp.value; refresh(); });
      plateSel.addEventListener("change", function () { state.plate = plateSel.value; refresh(); });

      slideTypeSel.addEventListener("change", function () { state.slideType = slideTypeSel.value; refresh(); });

      drawerDepthInp.addEventListener("input", function () {
        state.drawerDepthInput = drawerDepthInp.value;
        var depthIn = parseInches(state.drawerDepthInput);
        var recLen = recommendSlideLengthFromDepth(state.slideType, depthIn);
        if (recLen) { slideLenSel.value = recLen; state.slideLen = recLen; }
        refresh();
      });

      cabinetDepthInp.addEventListener("input", function () { state.cabinetDepthInput = cabinetDepthInp.value; refresh(); });
      drawersCountInp.addEventListener("input", function () { state.drawersCountInput = drawersCountInp.value; refresh(); });
      slideLenSel.addEventListener("change", function () { state.slideLen = slideLenSel.value; refresh(); });

      addHandlesChk.addEventListener("change", function () { state.addHandles = !!addHandlesChk.checked; refresh(); });
      handleSel.addEventListener("change", function () { state.handleAddonKey = handleSel.value; refresh(); });
      handlesNeededInp.addEventListener("input", function () { state.handlesNeededInput = handlesNeededInp.value; refresh(); });

      useRecoBtn.addEventListener("click", function () {
        var inf = inferredPullCount();
        if (!inf.total) return;
        state.handlesNeededInput = String(inf.total);
        handlesNeededInp.value = state.handlesNeededInput;
        refresh();
      });

      btn.addEventListener("click", onFind);

      // bind start triggers
      [modeSel, cabSel, overlayInp, doorThkInp, doorsCountInp, slideTypeSel, drawerDepthInp, drawersCountInp, slideLenSel, addHandlesChk, handleSel, handlesNeededInp].forEach(bindStart);

      // Layout
      var header = h("div", { class: "ff-card" }, [
        h("div", { class: "ff-title" }, "Find the right kit"),
        h("div", { class: "ff-sub" }, "Enter quantities and key measurements. We’ll build the best pack + singles combination automatically."),
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "What are you upgrading?"), modeSel]),
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "Cabinet type"), cabSel])
        ])
      ]);

      var hingeBreakdown = h("div", { class: "ff-note", style: "display:none;" });

      var hingeBox = h("div", { class: "ff-card", id: "hingeBox" }, [
        h("div", { class: "ff-title" }, "Hinges fitment"),
        h("div", { class: "ff-sub" }, "Enter overlay to confirm fitment. Enter door quantity to build packs + singles automatically."),
        overlayWarn, overlayHint, compactHingeNote,
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "Door overlay (inches)"),
            overlayInp,
            h("div", { class: "ff-kicker" }, 'Examples: 1/4, 1/2, 5/8, 0.5 (inch marks like " are OK)')
          ]),
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "Door thickness (optional)"),
            doorThkInp
          ])
        ]),
        overlayDetails,
        h("div", { class: "ff-hr" }),
        h("div", { class: "ff-sub", style: "margin:0 0 8px;" }, "Optional: calculate overlay using widths."),
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "Door width (optional)"), doorWidthInp]),
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "Opening width (optional)"), openingWidthInp])
        ]),
        h("div", { style: "margin-top:8px;" }, [calcOverlayBtn]),
        overlayCalcNote,
        h("div", { class: "ff-hr" }),
        plateHint,
        confidenceNote,
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "How many doors?"),
            doorsCountInp,
            h("div", { class: "ff-kicker" }, "Rule: <10 = singles only. 37 = 20-pack + 10-pack + 7 singles.")
          ]),
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "Plate height"),
            plateSel
          ])
        ]),
        hingeBreakdown,
        h("div", { class: "ff-note ff-warn" }, [
          h("div", { style: "font-weight:900;" }, "Plate height note"),
          h("div", { class: "ff-sub" }, "Safest option is matching the plate height already installed (often stamped 0 / 3 / 6).")
        ])
      ]);

      var slideBreakdown = h("div", { class: "ff-note", style: "display:none;" });

      var slideBox = h("div", { class: "ff-card", id: "slideBox" }, [
        h("div", { class: "ff-title" }, "Drawer slides fitment"),
        h("div", { class: "ff-sub" }, "Enter drawer depth to select slide length. Enter drawer quantity to build packs + singles automatically."),
        undermountInfo,
        undermountCabWarn,
        slideWarn,
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "Mount type"), slideTypeSel]),
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "Drawer box depth (inches)"),
            drawerDepthInp,
            h("div", { class: "ff-kicker" }, "Measure front-to-back of the drawer box")
          ]),
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "Interior cabinet depth (optional)"), cabinetDepthInp])
        ]),
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "How many drawers?"),
            drawersCountInp,
            h("div", { class: "ff-kicker" }, "Rule: <4 = all singles. 5/6/7 = 4-pack + 1/2/3 singles.")
          ]),
          h("div", { class: "ff-col" }, [h("label", { class: "ff-label" }, "Slide length"), slideLenSel])
        ]),
        slideBreakdown,
        h("details", {}, [
          h("summary", {}, "Side-mount vs undermount (what changes?)"),
          h("div", { class: "ff-sub", style: "margin-top:8px;" }, [
            "Side-mount slides attach to drawer sides and are more forgiving. ",
            "Undermount slides hide under the drawer and require specific drawer prep."
          ])
        ])
      ]);

      // Optional add-ons: handles + accessories
      var addOnInner = h("div", { style: "display:none;" }, [
        handlesReco,
        handlesHint,
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "Handle / pull style"),
            handleSel
          ]),
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "How many pulls/handles do you need? (optional)"),
            handlesNeededInp
          ])
        ])
      ]);

      var accessoryInner = h("div", { style: "margin-top:10px;" });

      // Build accessory UI once
      var accessoryUI = {};
      ACCESSORY_ADDONS.forEach(function (a) {
        var chk = h("input", { type: "checkbox", checked: !!state.accessorySelections[a.key] });
        chk.addEventListener("change", function () {
          state.accessorySelections[a.key] = !!chk.checked;
          markStart();
        });

        var wrap = h("label", { class: "ff-note", style: "display:flex;gap:10px;align-items:center;" }, [
          chk,
          h("div", {}, [
            h("div", { style: "font-weight:900;" }, a.label),
            h("div", { class: "ff-kicker" }, "Optional add-on.")
          ])
        ]);

        accessoryUI[a.key] = { wrap: wrap, chk: chk };
        accessoryInner.appendChild(wrap);
      });

      var addOnBox = h("div", { class: "ff-card", id: "addOnBox" }, [
        h("div", { class: "ff-title" }, "Optional add-ons"),
        h("div", { class: "ff-sub" }, "Add handles and accessories to finish the job."),
        h("div", { class: "ff-row" }, [
          h("div", { class: "ff-col" }, [
            h("label", { class: "ff-label" }, "Add cabinet pulls / handles?"),
            h("label", { class: "ff-note", style: "display:flex;gap:10px;align-items:center;" }, [
              addHandlesChk,
              h("div", {}, [
                h("div", { style: "font-weight:900;" }, "Yes — add handles"),
                h("div", { class: "ff-kicker" }, "Optional.")
              ])
            ])
          ])
        ]),
        addOnInner,
        h("div", { class: "ff-hr" }),
        h("div", { style: "font-weight:900;margin-bottom:8px;" }, "Accessories"),
        accessoryInner
      ]);

      var actions = h("div", { class: "ff-card" }, [
        btn,
        h("div", { style: "margin-top:10px;" }, [statusLine]),
        resultBox
      ]);

      el.innerHTML = "";
      el.appendChild(header);
      el.appendChild(hingeBox);
      el.appendChild(slideBox);
      el.appendChild(addOnBox);
      el.appendChild(actions);

      refresh();
    }

    render();
  });
})();